export const getSingleFlavorConsumable = (consumable) => {
    const flavorDetails = consumable.product?.flavorDetails?.[0];
    const flavorName = flavorDetails?.name;
    // TODO: Remove check for flavour_label when sticks matrix is removed
    const flavorNameFallback = "flavour_label" in consumable && consumable.flavour_label ? consumable.flavour_label : consumable.product?.name;
    return {
        sku: consumable.sku,
        name: flavorName ?? flavorNameFallback,
        description: flavorDetails?.description,
        attributes: flavorDetails?.attributes_custom_?.map(({ id, name, sort_order, value }) => ({
            id: +id,
            name,
            sortOrder: +sort_order,
            value,
        })),
        image: {
            url: consumable.product?.thumbnail?.url,
        },
    };
};
//# sourceMappingURL=getSingleFlavorConsumable.js.map